import m, {MithrilComponent} from '@bitstillery/mithril'
import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

/**
 * Sunken inset panel that content sinks into (e.g. a category strip). Pure layout — wrap a `Grid` or
 * other content in it; put a `Section` title above the `Well`, not inside it.
 */
export const wellMeta = {
    tier: 'layout',
    summary: 'Recessed inset panel that content sinks into (e.g. a category strip).',
    when_to_use:
        'Wrap a `Grid` (or other content) to set it in a muted sunken surface. Put a `Section` title above the Well, not inside it.',
    props: 'No props — children only.',
    example: `
    <Well>
        <List items={['Verified suppliers', 'Live stock levels']} type="check" />
        <Button link="/contact" text="Talk to us" type="info" />
    </Well>
    `,
} satisfies CmsComponentMeta

export class Well extends MithrilComponent {
    view(vnode: m.Vnode) {
        return <div className='c-well'>{vnode.children}</div>
    }
}
